import script from "./designation.vue?vue&type=script&setup=true&lang=js"
export * from "./designation.vue?vue&type=script&setup=true&lang=js"

import "./designation.vue?vue&type=style&index=0&id=02f4d4f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02f4d4f7"]])

export default __exports__